/**
 * Labstep
 *
 * @module components/Entity/Table/BulkSelect
 * @desc Table with bulk select capability for multiple entities
 */

import { BulkSelectContext } from 'labstep-web/contexts/bulk-select';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { TableSimple } from 'labstep-web/core/Table/Simple';
import type React from 'react';
import styles from './styles.module.scss';
import type { EntityTableBulkSelectProps } from './types';
import { bulkSelectColumn } from './utils';

export const EntityTableBulkSelect: React.FC<
  EntityTableBulkSelectProps
> = ({
  columns,
  entities,
  withCheckbox,
  singleSelect,
  lastHeader,
  ...rest
}) => {
  let columnsWithBulk = columns;
  if (singleSelect) {
    columnsWithBulk = [
      ...columns,
      {
        header: null,
        content: (
          entity: (typeof entities)[0],
        ): React.ReactElement => (
          <BulkSelectContext.Consumer>
            {({ toggleSelection }): React.ReactElement => (
              <ActionComponent
                type="button"
                text="Select"
                onClick={(): void => toggleSelection(entity)}
              />
            )}
          </BulkSelectContext.Consumer>
        ),
      },
    ];
  } else if (withCheckbox) {
    columnsWithBulk = [bulkSelectColumn, ...columns];
  }

  const lastColumn = columnsWithBulk[columnsWithBulk.length - 1];
  lastColumn.header = lastHeader;
  lastColumn.cellProps = {
    ...lastColumn.cellProps,
    className: styles.lastColumn,
  };

  return (
    <TableSimple
      columns={columnsWithBulk}
      rows={entities}
      {...rest}
    />
  );
};
